import { UserReward } from '../types/offers';

/**
 * Formats a user reward for display based on its type
 * Based on Kard API: Commission.value is a double (dollars for FLAT, percentage for PERCENT)
 * @param reward - The user reward object with type and value
 * @returns Formatted string (e.g., "5% cash back" or "$10 cash back")
 */
export function formatReward(reward: UserReward): string {
  const normalizedType = reward.type?.toUpperCase();

  if (normalizedType === 'FLAT') {
    // Handle null/undefined values gracefully
    if (reward.value == null) {
      return '$0 cash back';
    }
    const formattedValue = Number.isInteger(reward.value)
      ? reward.value.toString()
      : reward.value.toFixed(2);
    return `$${formattedValue} cash back`;
  } else {
    return `${reward.value}% cash back`;
  }
}

